export class ASDocument {
  id: number;
  htmlRendering: string;
  text: string;
  fileName: string;
  metaData: MetaData;
  activityFeed: Array<Activity>;
  relatedDocumentArray: Array<RelatedDocument>;
  thumbnail: string;
}

export class MetaData {
  document_type: string;
  file_size: number;
  owner: string;
  source: string;
  date: Date;
  file_path: string;
}

export class Activity {
  actor: string;
  action: string;
  date: Date;
}

export class RelatedDocument {
  id: number;
  fileName: string;
  screenshotPath: string;
}